;( function( $, undefined )
{
    $.fn.FirstThreadQuickExe = function()
    {
        if( window.FirstThreadQuickExeDone )
        {
            return;
        }

        window.FirstThreadQuickExeDone = true;

        var $pdc6       = $( '#PDC6-main-container' );
        var currentPage = $( '.lia-paging-full-wrapper' ).eq( 0 ).find( '.lia-paging-full-pages span.lia-link-disabled' ).text();

        if( $pdc6.hasClass( 'thread-page-1' ) && currentPage > 1 )
        {
            $pdc6.removeClass( 'thread-page-1' ).addClass( 'thread-page-2' );
        }

        var $report = $( '.lia-link-navigation.report-abuse-link' ).clone()
          , $first  = $( '.first-message' );

        var $drop = $( '#actionMenuDropDown' ).detach();
        var $clone = $drop.clone();

        $drop.appendTo( '.thread-opening' );
        $clone.appendTo('.mobile-only-author');

        $clone.find('.lia-js-menu-opener.default-menu-option').html('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="36" height="16" viewBox="0 0 36 16"><path d="M30.062,13.005 L23.999,7.104 L26.159,5.002 L30.062,8.669 L33.683,5.042 L36.004,7.223 L30.062,13.005 ZM13.822,10.758 L14.652,12.948 L13.109,14.574 L11.036,13.750 L10.095,14.145 L9.270,16.001 L7.053,16.001 L6.251,14.156 L5.359,13.772 L3.320,14.552 L1.760,12.948 L2.563,10.829 L2.340,10.324 L-0.000,9.248 L-0.000,6.997 L2.340,5.920 L2.585,5.371 L1.716,3.076 L3.276,1.483 L5.582,2.384 L6.128,2.176 L7.075,0.001 L9.281,0.001 L10.240,2.154 L10.763,2.384 L13.014,1.483 L14.607,3.087 L13.760,5.349 L14.061,6.096 L16.000,6.997 L16.000,9.270 L14.061,10.148 L13.822,10.758 ZM8.000,5.449 C6.569,5.449 5.410,6.591 5.410,8.001 C5.410,9.412 6.569,10.554 8.000,10.554 C9.431,10.554 10.591,9.412 10.591,8.001 C10.591,6.591 9.431,5.449 8.000,5.449 Z" class="cls-1"/></svg>');
        $clone.after('<div class="dropdown-backdrop"></div>');

        $( '.lia-panel-message-root' ).find( '.share' ).prepend( $report.addClass( 'report-abuse-link' ) );

        var $staff = $first.find( '.author-hover-block' ).before( $first.find( '.staff-post' ) );

        if( $first.find( '.staff-author' ).size() > 0 )
        {
            $( '#actionMenuDropDown' ).addClass( 'staff-author' );
        }

        $first.find( '.recommend-via-mail' ).click( function( e )
        {
            e && e.preventDefault();

            var $link = $first.find( '.lia-component-forums-action-email-message-to-friend' );

            window.location = $link.attr( 'href' );
        } );

        if( $( '#informationbox' ).size() > 0 && $( '#notification-bar' ).size() == 0 )
        {
            var message = $.trim( $( '#informationbox' ).text() );
            $( '#common-hidden-inline-loader' ).after( '<div id="notification-bar" class="success"><div id="notifiction-message"><p><span><!-- --></span>' + message + '</p></div></div>' );
        }


        var timer = setInterval(function () {
            var $m = $('#threadeddetaildisplaymessageviewwrapper_0');
            if ($m.size()) {
                clearInterval(timer);
                if ($m.children().hasClass('lia-thread-level-00')) {
                    $m.after($('#after-first-message').detach().addClass('after-accepted'));
                }
            }
        }, 200);

        setTimeout(function () {
            clearInterval(timer);
        }, 10000);

        var replies = $('.thread-details .replies').text().match(/\d+/)[0];

        if (replies == 0) {
            $('#PDC6-main-container').addClass('thread-no-replies');
        }
    };

} )( jQuery );
